
import React, { useState, useRef, useEffect } from 'react';
import api from '../services/api';
import { getProfile, getUsername } from "../utils/formatters";

function ProfileDropdown({ user, activeProfile, setActiveProfile }) {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState("Select Profile?");


    //const options = ["Profile", "ELV Varkala", "Help"];
    const options = user?.profiles || [];   // ✅ dynamic

    useEffect(() => {
        if (!activeProfile) {
            console.log("Point 1");
            //const token = localStorage.getItem("token");
            //const decoded = parseJwt(token);
            //console.log(decoded);
            //if(options.length>0){
//                const profile=options[0];
  //              if (profile) setSelected(profile);
            //}else{
                const profile=getProfile();
                if (profile) setSelected(profile);
            //}
            
            //const storedUser = localStorage.getItem('user');
            //console.log(storedUser)
        } else {
            console.log("Point 2");
            setSelected(activeProfile);
        }
        //loadTreeData();
        console.log("activeProfile=" + activeProfile)
    }, [activeProfile]);




    return (
        <div style={{ position: "relative", marginTop: "10px" }}>

            {/* Dropdown Button */}
            <div
                onClick={() => setOpen(!open)}
                style={{
                    width: '100%',
                    height: '38px',                 // ✅ same height
                    display: 'flex',
                    alignItems: 'center',           // ✅ vertical center
                    padding: '0 12px',              // ✅ match button
                    backgroundColor: '#f3f4f6',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '15px',
                    fontWeight: 'bold',
                    border: '1px solid #e5e7eb',
                    color: 'orangered'
                }}
            >
                {selected}
            </div>

            {/* Dropdown List */}
            {open && (
                <div
                    style={{
                        position: "absolute",
                        top: "40px",
                        left: 0,
                        width: "100%",
                        backgroundColor: "#fff",
                        border: "1px solid #e5e7eb",
                        borderRadius: "8px",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                        zIndex: 100
                    }}
                >
                    {options.length > 0 ? (

                        options.map((opt, index) => (
                            <div
                                key={opt}
                                onClick={() => {
                                    setSelected(opt);
                                    setOpen(false);
                                    console.log("Selected profile:", opt);
                                    console.log(user);
                                    //setActiveProfile(opt);
                                    //--------------------------    
                                    api.post('/auth/switch-profile', { username: user.m_username, Profile: opt })
                                        .then(res => {
                                            localStorage.setItem("token", res.token);
                                            setActiveProfile(opt);
                                            console.log("Selected profile configured:", opt);
                                            console.log(res);
                                        });
                                    //--------------------------

                                }}

                                style={{
                                    padding: "8px 12px",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                    fontWeight: 'bold'
                                }}
                                onMouseEnter={(e) =>
                                    (e.target.style.background = "#f9fafb")
                                }
                                onMouseLeave={(e) =>
                                    (e.target.style.background = "transparent")
                                }
                            >
                                {opt}
                            </div>
                        ))
                    ) : (
                        <div style={{ padding: "8px 12px", color: "#9ca3af" }}>
                            No profiles
                        </div>
                    )}

                </div>
            )}
        </div>
    );
}

export default ProfileDropdown;